import React, { Component } from 'react';
import * as Styles from './Styles';

type Props = {
	onClick: () => void;
	isActive: boolean;
};

type State = {};

class Switch extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper
				isActive={this.props.isActive}
				onClick={this.props.onClick}
			>
				<Styles.Dot isActive={this.props.isActive} />
			</Styles.Wrapper>
		);
	}
}

export default Switch;
